import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useDashboardContext } from '../contexts/DashboardContext';
import { useModal } from '../contexts/ModalContext';
import { DashboardHeader } from '../components/dna/DashboardHeader';
import ProfileHeader from '../components/settings/ProfileHeader';
import ProfileSection from '../components/settings/ProfileSection';
import SecuritySection from '../components/settings/SecuritySection';
import NotificationsSection from '../components/settings/NotificationsSection';
import IntegrationsSection from '../components/settings/IntegrationsSection';
import SubscriptionSection from '../components/settings/SubscriptionSection';
import '../styles/pages/settings.css';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const tabs = [
    { id: 'profile', label: 'Profil', icon: 'fa-user' },
    { id: 'account', label: 'Compte', icon: 'fa-lock' },
    { id: 'notifications', label: 'Notifications', icon: 'fa-bell' },
    { id: 'integrations', label: 'Intégrations', icon: 'fa-comments' },
    { id: 'subscription', label: 'Abonnement', icon: 'fa-crown' },
  ];
  const activeLabel = tabs.find((t) => t.id === activeTab)?.label || activeTab;
  const { confirmSave } = useModal();
  const { toggleMobileMenu } = useOutletContext();

  const {
    data,
    profilePic,
    handleUpdateProfile,
    telegramCode,
    telegramCodeExpiresAt,
    telegramCodeLoading,
    telegramCodeError,
    telegramCodeCopied,
    showTelegramModal,
    setShowTelegramModal,
    handleGenerateTelegramCode,
    handleCopyTelegramCode,
    handleTestTelegram,
    formatDateTime,
    handleConfirmCrop,
  } = useDashboardContext();

  const onUpdateProfile = async (formData) => {
    let result = false;
    await confirmSave({
      message: 'Enregistrer les modifications apportées à votre profil ?',
      onConfirm: async () => {
        result = await handleUpdateProfile(formData);
      }
    });
    return result;
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'profile':
        return (
          <>
            <ProfileHeader
              artist={data?.artist}
              profilePic={profilePic}
              onConfirmCrop={handleConfirmCrop}
            />
            <ProfileSection
              key={data?.artist?.id || 'profile-empty'}
              artist={data?.artist}
              onSave={onUpdateProfile}
              telegramCode={telegramCode}
              telegramCodeExpiresAt={telegramCodeExpiresAt}
              telegramCodeLoading={telegramCodeLoading}
              telegramCodeError={telegramCodeError}
              telegramCodeCopied={telegramCodeCopied}
              showTelegramModal={showTelegramModal}
              onShowTelegramModal={setShowTelegramModal}
              onGenerateTelegramCode={handleGenerateTelegramCode}
              onCopyTelegramCode={handleCopyTelegramCode}
              onTestTelegram={handleTestTelegram}
              formatDateTime={formatDateTime}
            />
          </>
        );
      case 'account':
        return <SecuritySection />;
      case 'notifications':
        return <NotificationsSection />;
      case 'integrations':
        return (
          <IntegrationsSection
            artist={data?.artist}
            telegramCode={telegramCode}
            telegramCodeExpiresAt={telegramCodeExpiresAt}
            telegramCodeLoading={telegramCodeLoading}
            telegramCodeError={telegramCodeError}
            telegramCodeCopied={telegramCodeCopied}
            showTelegramModal={showTelegramModal}
            onShowTelegramModal={setShowTelegramModal}
            onGenerateTelegramCode={handleGenerateTelegramCode}
            onCopyTelegramCode={handleCopyTelegramCode}
            onTestTelegram={handleTestTelegram}
            formatDateTime={formatDateTime}
          />
        );
      case 'subscription':
        return <SubscriptionSection artist={data?.artist} />;
      default:
        return (
          <ProfileSection
            artist={data?.artist}
            onSave={onUpdateProfile}
            telegramCode={telegramCode}
            telegramCodeExpiresAt={telegramCodeExpiresAt}
            telegramCodeLoading={telegramCodeLoading}
            telegramCodeError={telegramCodeError}
            telegramCodeCopied={telegramCodeCopied}
            showTelegramModal={showTelegramModal}
            onShowTelegramModal={setShowTelegramModal}
            onGenerateTelegramCode={handleGenerateTelegramCode}
            onCopyTelegramCode={handleCopyTelegramCode}
            onTestTelegram={handleTestTelegram}
            formatDateTime={formatDateTime}
          />
        );
    }
  };

  return (
    <>
      <DashboardHeader
        title="Paramètres"
        subtitle={`Gérez votre compte et vos intégrations · ${new Date().getFullYear()}`}
        onMenu={toggleMobileMenu}
      />
      <div className="dashboard-content">
      <div className="settings-layout">
        <nav className="settings-nav">
          {tabs.map(({ id, label, icon }) => (
            <button key={id} className={activeTab === id ? 'active' : ''} onClick={() => setActiveTab(id)}>
              <i className={`fa-solid ${icon}`} style={{ width: 17 }} />{label}
            </button>
          ))}
        </nav>
        <div className="settings-panel">
          <div className="panel-heading">
            <span className="content-kicker">Configuration</span>
            <h2>{activeLabel}</h2>
            <p>Les informations de votre espace artiste.</p>
          </div>
          {renderContent()}
        </div>
      </div>
      </div>
    </>
  );
};

export default Settings;
